var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-user user-icon"}),_vm._l((_vm.names),function(n,$index){return _c('span',{key:n},[_vm._v("\n    "+_vm._s(n)),(_vm.numItems === $index)?[_vm._v(",")]:_vm._e()],2)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }